import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { useFetchVerifiedRefurbishCarousel } from '~/scopes/product-core/composables/useFetch/useFetchVerifiedRefurbishCarousel/useFetchVerifiedRefurbishCarousel'

export function useVerifiedRefurbishedCarousel() {
  const config = useRuntimeConfig()
  const { countryCode } = useMarketplace().market
  const { data: checkpoints, pending: checkpointsPending } =
    useFetchVerifiedRefurbishCarousel()

  const isEnabledForMarket =
    config.public.FF_ENABLE_VERIFIED_REFURBISHED_LINK_PP.includes(countryCode)

  const shouldDisplayVerifiedRefurbishedCarousel = computed(() => {
    return (
      (checkpoints.value ? checkpoints.value.items.length > 0 : false) &&
      isEnabledForMarket
    )
  })

  const isDisplayPendingVerifiedRefurbishedCarousel = computed(() => {
    return checkpointsPending.value && isEnabledForMarket
  })

  return {
    shouldDisplayVerifiedRefurbishedCarousel,
    isDisplayPendingVerifiedRefurbishedCarousel,
  }
}
